import { Button } from "@/components/ui/Button";
import { PlusIcon } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";

export function GamesAndLiveEventsHeader() {
  const { t } = useTranslation();
  const { navToRoute } = useProtectedNavigation();

  return (
    <section
      className="flex items-center justify-between border-b p-6 pb-4"
      role="region"
      data-testid="games-and-live-events-header"
      aria-labelledby="games-and-live-events-title"
    >
      <h2 id="games-and-live-events-title" className="text-2xl font-bold">
        {t("gamesAndLiveEvents.title")}
      </h2>
      <Button
        data-testid="create-new-event-button"
        onClick={() => navToRoute("editEvent")}
      >
        <PlusIcon />
        {t("gamesAndLiveEvents.createNewEvent")}
      </Button>
    </section>
  );
}
